<template>
  <div class="each-conference-wrap">
    <h1>{{conference.loc_name}}</h1>
    <div class="conference-details">
      <link-wrap v-for="link in conference.links" :key="link.stl_id"
        :linkObj="link"
        @select-link="$emit('edit-link', $event)"
        @confirm-delete="$emit('confirm-delete', $event)"
        @edit-link="$emit('edit-link', $event)"
      ></link-wrap>
      <button class="add-button" @click="$emit('add-link', conference.loc_id)">{{$t('button.addLink')}}</button>
    </div>
  </div>
</template>

<script>
import LinkWrap from './LinkWrap';
export default {
  components: {
    LinkWrap
  },
  props: {
    conference: Object
  }
}
</script>

<style scoped>
.each-conference-wrap {
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 0px 36px -11px rgba(0,0,0,0.75);
  border-radius: 20px;
  padding-bottom: 20px;
  margin: 25px 0;
}
.conference-details {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.add-button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  border: none;
  padding: 2% 4%;
  border-radius: 100px;
  font-size: 15px;
  font-weight: 600;
  background: var(--button-color-blue);
  color:white;
  margin-top: 25px;
}
.add-button:active, .add-button:focus {
  border: none;
  outline: none;
}
</style>